import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    confirm: {
        defaultMessage: 'Confirm',
        id: 'iaso.label.confirm',
    },
    cancel: {
        defaultMessage: 'Cancel',
        id: 'iaso.label.cancel',
    },
    quantity: {
        id: 'iaso.polio.label.quantity',
        defaultMessage: 'Quantity',
    },
    currentExpirationDate: {
        id: 'iaso.polio.label.currentExpirationDate',
        defaultMessage: 'Current expiration date',
    },
    status: {
        id: 'iaso.polio.table.label.status',
        defaultMessage: 'Status',
    },
    comment: {
        defaultMessage: 'Comment',
        id: 'iaso.polio.label.comment',
    },
    addAuthorisation: {
        defaultMessage: 'Add authorisation',
        id: 'iaso.polio.button.label.addAuthorisation',
    },
    editAuth: {
        id: 'iaso.polio.title.editAuth',
        defaultMessage: 'Edit authorisation',
    },
    country: {
        id: 'iaso.polio.table.label.country',
        defaultMessage: 'Country',
    },
    expirationDate: {
        id: 'iaso.polio.label.expirationDate',
        defaultMessage: 'Expiration date',
    },
    vaccineAuthStartDate: {
        id: 'iaso.polio.label.vaccineAuthStartDate',
        defaultMessage: 'Start Date',
    },
});
export default MESSAGES;
